import { AddressInput } from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

export const useCreateFacilityMutation = createMutationHook(
  'facilities.facilityCreate',
  (params: {
    facilityName: string;
    facilityType: string;
    facilityGroupId?: string;
    timezone: string;
    address: AddressInput;
  }) => ({
    coreFacilityCreate: {
      __args: {
        input: {
          facilityName: params.facilityName,
          facilityType: params.facilityType,
          facilityGroupId: params.facilityGroupId,
          timezone: params.timezone,
          address: params.address,
        },
      },
      id: true,
    },
  }),
);
